"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var immutable_1 = require("immutable");
var getDisplayName_1 = require("../utils/getDisplayName");
var mapValues_1 = require("../utils/mapValues");
var createProvider_1 = require("../provider/createProvider");
var memoize_one_1 = require("memoize-one");
var capitalize = function (s) { return s.charAt(0).toUpperCase() + s.slice(1); };
var createComponent = function (_a) {
    var field = _a.field, feature = _a.feature, handlers = _a.handlers, mapProps = _a.mapProps, BaseComponent = _a.BaseComponent, _b = _a.key, key = _b === void 0 ? '' : _b;
    var storeKey = !!key && key || 'default';
    var displayName = "Connect" + capitalize(field) + "(" + getDisplayName_1.getDisplayName(BaseComponent) + ")";
    var factory = react_1.createFactory(BaseComponent);
    var Connect = (function (_super) {
        __extends(Connect, _super);
        function Connect(props) {
            var _this = _super.call(this, props) || this;
            _this.cachedHandlers = {};
            _this.handleUpdate = function (changes, meta, direct) {
                if (meta === void 0) { meta = immutable_1.Map(); }
                if (direct === void 0) { direct = false; }
                var analytics = _this.props.analytics;
                var mapped = mapProps && mapProps(changes, meta, _this.changeAction, analytics);
                var state = __assign({ meta: meta }, (mapped || (_a = {}, _a[field] = changes, _a)));
                direct ? _this.state = state : _this.setState(state);
                var _a;
            };
            _this.handlers = mapValues_1.default(handlers, function (createHandler, handlerName) { return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var cachedHandler = _this.cachedHandlers[handlerName];
                if (cachedHandler)
                    return cachedHandler.apply(void 0, args);
                var handler = createHandler(__assign({ update: _this.changeAction, analytics: _this.props.analytics }, _this.state));
                _this.cachedHandlers[handlerName] = handler;
                return handler.apply(void 0, args);
            }; });
            _this.makeHandlers = memoize_one_1.default(function (state) {
                var analytics = _this.props.analytics;
                return mapValues_1.default(handlers, function (createHandler, handlerName) { return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var handler = createHandler(__assign({ analytics: analytics, update: _this.changeAction }, state));
                    return handler.apply(void 0, args);
                }; });
            });
            var $store = props.agent;
            if (!$store) {
                throw new Error("\n          Can't find Provider \"" + (storeKey ? ' with key ' + storeKey : '') + ",\n          You should create provider with correct Agent, or set \"storeKey\"\n        ");
            }
            _this.changeAction = $store.set;
            _this.handleUpdate(field !== 'query' ? $store.response.get(field) : $store.state, $store.response.get('meta'), true);
            return _this;
        }
        Connect.prototype.componentWillMount = function () {
            this.props.agent.on("change:" + field, this.handleUpdate);
        };
        Connect.prototype.componentWillUnmount = function () {
            this.props.agent.off(this.handleUpdate);
        };
        Connect.prototype.shouldComponentUpdate = function (nextProps, nextState) {
            var _this = this;
            return ((!this.state[field] || !this.state[field].equals(nextState[field]) || !this.state.meta.equals(nextState.meta))
                || !!Object.keys(nextProps).find(function (key) { return !immutable_1.is(nextProps[key], _this.props[key]); }));
        };
        Connect.prototype.componentWillReceiveProps = function () {
            this.cachedHandlers = {};
        };
        Connect.prototype.render = function () {
            return factory(__assign({}, this.state, this.props, this.makeHandlers(this.state), { update: this.changeAction }));
        };
        return Connect;
    }(react_1.Component));
    Connect.prototype.displayName = displayName;
    return function (props) { return react_1.createElement(createProvider_1.Context.Consumer, null, function (agents) {
        return react_1.createElement(Connect, __assign({}, props, agents[storeKey]));
    }); };
};
exports.default = (function (_a) {
    var field = _a.field, handlers = _a.handlers, mapProps = _a.mapProps;
    return function (connector) {
        return typeof connector === 'function'
            ? createComponent({
                field: field,
                handlers: handlers,
                mapProps: mapProps,
                BaseComponent: connector
            })
            : function (BaseComponent) {
                return createComponent(__assign({ field: field,
                    handlers: handlers,
                    mapProps: mapProps,
                    BaseComponent: BaseComponent }, connector));
            };
    };
});
//# sourceMappingURL=createConnect.js.map